// @ts-nocheck
import { Component } from "@theme/component";
//@ts-ignore
import BlazeSlider from "@lib/blaze-slider";

/**
 * Cart Drawer Addon Component
 * @extends {Component}
 */
export class WhatsIncluded extends Component {
  /** @type {BlazeSlider|null} */
  slider = null;
  sliderContents = this.querySelectorAll(".blaze-slider-content-item");
  lastPageInfo = {};
  totalSlides = null;
  pageIndex = 0;
  prevButton = null;
  nextButton = null;

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  /**
   * Update navigation button visibility based on current position
   */
  updateNavigationState() {
    if (!this.prevButton || !this.nextButton) return;

    // Hide prev button on first page
    this.prevButton.style.display = this.pageIndex === 0 ? 'none' : 'flex';
    
    // Hide next button on last page
    this.nextButton.style.display = 
      this.pageIndex >= this.lastPageInfo.first ? 'none' : 'flex';
  }

  /**
   * Activate a specific slide and its content
   */
  clickSlide(idx) {
    // Update slide active states
    [...this.slider.slides].forEach((s, index) => {
      s.classList.toggle("active", index === idx);
    });

    // Update content active states
    this.sliderContents.forEach((content, index) => {
      content.classList.toggle("active", index === idx);
    });

    // Handle navigation based on clicked slide position
    if (idx >= this.lastPageInfo.first) {
      // If clicking on last page, jump to show last page
      const slidesToMove = this.lastPageInfo.last - this.lastPageInfo.first;
      this.slider.next(slidesToMove);
    } else if (idx < this.pageIndex) {
      // If clicking backwards, go to that slide
      this.slider.prev(this.pageIndex - idx);
    } else if (idx > this.pageIndex && idx < this.lastPageInfo.first) {
      // If clicking forwards but not on last page
      this.slider.next(idx - this.pageIndex);
    }
  }

  /**
   * Handle navigation button clicks
   */
  navigationSlide(nav) {
    const action = nav.dataset.action;
    if (action === "prev") {
      this.slider.prev();
    } else if (action === "next") {
      this.slider.next();
    }
  }

  /**
   * Initialize the slider
   */
  initSlider() {
    const sliderSelector = this.querySelector(".blaze-slider.whats-included");
    this.slider = new BlazeSlider(sliderSelector, {
      all: {
        slidesToScroll: 1,
        slidesToShow: 5,
        slideGap: "0px",
        loop: false,
      },
      '(max-width: 750px)': { slidesToShow: 3 },
    });

    // Cache navigation button references
    this.prevButton = this.querySelector('.blaze-navigation[data-action="prev"]');
    this.nextButton = this.querySelector('.blaze-navigation[data-action="next"]');

    // Add click handlers to slides
    if (this.slider.slides.length) {
      [...this.slider.slides].forEach((slide) => {
        slide.addEventListener("click", () => {
          this.clickSlide(Number(slide.dataset.index));
        });
      });
    }

    // Disable component if slider is static
    if (this.slider.isStatic) {
      this.classList.add("disable");
    }

    // Add navigation button handlers
    const navigation = this.querySelectorAll(".blaze-navigation");
    navigation.forEach((nav) => {
      nav.addEventListener("click", () => this.navigationSlide(nav));
    });

    // Store last page info
    const [first, last] = this.slider.states.at(-1).page;
    this.lastPageInfo = { first, last };
    this.totalSlides = this.slider.totalSlides - 1;

    // Handle slider state changes
    this.slider.onSlide(
      (pageIndex, firstVisibleSlideIndex, lastVisibleSlideIndex) => {
        this.pageIndex = pageIndex;
        this.clickSlide(firstVisibleSlideIndex);
        this.updateNavigationState();
      },
    );

    // Set initial navigation state
    this.updateNavigationState();
  }

  /**
   * Destroy the slider instance
   */
  destroySlider() {
    if (this.slider) {
      this.slider.destroy();
      this.slider = null;
    }
  }
}

if (!customElements.get("whats-included")) {
  customElements.define("whats-included", WhatsIncluded);
}